import { TenCoordinatorV1 } from '@frontend/api-tendlc-coordinator';
import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { useMatchRoute, type AnyRoute } from '@frontend/weave-router';

export const BRIDGELINE_PATH = '/bridgeline';

export const useBridgelineRedirect = () => {
  const matchRoute = useMatchRoute();
  const { selectedLocationIds, accessibleLocationIds } = useAppScopeStore();
  const { getFeatureFlagValue } = useAppFlagStore();

  const isBridgelineRoute = !!matchRoute({ to: BRIDGELINE_PATH as AnyRoute });

  const locationIdsToCheck = selectedLocationIds.length > 0 ? selectedLocationIds : accessibleLocationIds;

  const bridgelineLocationId =
    locationIdsToCheck.find((id) =>
      getFeatureFlagValue({
        locationIds: [id],
        flagName: 'bridgeline:10dlc-fastpass',
        strategy: 'ALL',
      })
    ) ?? '';

  const { data: tcrBrandData, isLoading: isTcrBrandLoading } = TenCoordinatorV1.Queries.useGetLocationTCRBrandQuery(
    { locationId: bridgelineLocationId },
    { enabled: !!bridgelineLocationId, refetchOnWindowFocus: false },
    { headers: { 'Location-Id': bridgelineLocationId } }
  );

  const hasExistingBrand = !!tcrBrandData?.tcrBrand?.brandId || !!tcrBrandData?.tcrBrand?.updatedAt;

  const isBridgelineEligible = !!bridgelineLocationId && !isTcrBrandLoading && !hasExistingBrand;

  return {
    bridgelineRedirectUrl: isBridgelineEligible && !isBridgelineRoute ? BRIDGELINE_PATH : '',
    bridgelineLocationId: isBridgelineEligible ? bridgelineLocationId : '',
    // Used by the route to show a loader while the TCR brand check is in flight
    isBridgelineLoading: !!bridgelineLocationId && isTcrBrandLoading,
  };
};
